import { ActionIcon, Text } from "@mantine/core"
import { IconDownload } from "@tabler/icons-react"
import { BaseSyntheticEvent, useState } from "react"

import { httpClient } from "~/backend/axios"

type Props = {
  documentId: string
  documentName: string
  showAsText?: boolean
  customText?: string
  filename?: string
}
export function DocumentDownload({
  documentId,
  documentName,
  showAsText,
  customText,
  filename,
}: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const [downloadUrl, setDownloadUrl] = useState<string>()

  const handleDownloadDocument = async (e: BaseSyntheticEvent) => {
    e.stopPropagation()
    if (!downloadUrl) {
      setIsLoading(true)
      const response = await httpClient.get(
        `/documents/${documentId}?download=true${filename ? `&filename=${documentName}` : ""}`
      )
      setDownloadUrl(response.data.url)
      setIsLoading(false)
      download(response.data.url)
    } else {
      download(downloadUrl)
    }
  }

  const download = (url: string) => {
    const element = document.createElement("a")
    element.href = url
    element.download = documentName.endsWith(".pdf")
      ? documentName
      : `${documentName}.pdf`

    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)

    URL.revokeObjectURL(url)
  }

  return showAsText ? (
    <Text fz="sm" onClick={handleDownloadDocument}>
      {customText ? customText : "Download"}
    </Text>
  ) : (
    <ActionIcon
      onClick={handleDownloadDocument}
      loading={isLoading}
      variant="transparent"
      color="gray"
    >
      <IconDownload />
    </ActionIcon>
  )
}
